import { useLoggedInUserIsMinimalInRole } from './useLoggedInUserIsMinimalInRole';

export function useLoggedInUserIsSuperUser(): boolean {
	return useLoggedInUserIsMinimalInRole('SuperUser');
}
